import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slices/authSlices";
import adminAuthReducer from "./slices/adminAuthSlices";
import propertiesReducer from "./slices/propertiesSlices";
import bankerAuthReducer from "./slices/bankerAuthSlices";
import bidderAuthReducer from "./slices/bidderAuthSlices";
import buyerAuthReducer from "./slices/buyerAuthSlices";
import sellerAuthReducer from "./slices/sellerAuthSlices";
import { encryptTransform } from "redux-persist-transform-encrypt";

const encryptor = encryptTransform({
  secretKey: `${process.env.NEXT_PUBLIC_REDUX_SECRET_KEY}`,
  onError: function (error) {
    // Handle the error.
    console.log("check here error:>", error);
  },
});

let reducers = combineReducers({
  auth: authReducer,
  adminAuth: adminAuthReducer,
  properties: propertiesReducer,
  bankerAuth: bankerAuthReducer,
  bidderAuth: bidderAuthReducer,
  buyerAuth: buyerAuthReducer,
  sellerAuth: sellerAuthReducer,
});

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: [
    "auth",
    "adminAuth",
    "properties",
    "bankerAuth",
    "bidderAuth",
    "buyerAuth",
    "sellerAuth",
  ],
  transforms: [encryptor],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const webStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV === "development" ? true : false,
});

const webPersistor = persistStore(webStore);

export { webStore, webPersistor };
